import ContractForm from '@/components/contracts/ContractForm'
import { Contract, ContractFormValues, SharedProps, Zone } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Container, Paper, Stack, Title } from '@mantine/core'

interface EditContractPageProps extends SharedProps {
  contract: Contract
  zones: Zone[]
}

export default function EditContractPage({ contract, current_organization, zones }: EditContractPageProps) {
  const handleUpdateContract = (values: ContractFormValues) => {
    router.put(`/organizations/${current_organization!.slug}/contracts/${contract.id}`, {
      contract: values,
    })
  }

  return (
    <>
      <Head title={`Modifier ${contract.customer_name} - ${current_organization?.name}`} />

      <Container size="sm">
        <Stack gap="xl">
          <Title>Modifier le contrat</Title>

          <Paper withBorder radius="md" p="md">
            <ContractForm
              onSubmit={handleUpdateContract}
              initialValues={{
                customer_name: contract.customer_name,
                customer_address: contract.customer_address,
                customer_phone_number: contract.customer_phone_number,
                customer_email: contract.customer_email,
                collected_by_provider: contract.collected_by_provider,
                sms_enabled: contract.sms_enabled,
                zone_id: contract.zone_id,
                default_days_to_deliver: contract.default_days_to_deliver,
                legal_name: contract.legal_name,
                siren: contract.siren,
                siret: contract.siret,
                vat_number: contract.vat_number,
                street_address: contract.street_address,
                postal_code: contract.postal_code,
                city: contract.city,
                electronic_address: contract.electronic_address,
              }}
              zones={zones}
              showSmsNotification={contract.customer_organization_id === null}
              submitLabel="Mettre à jour le contrat"
            />
          </Paper>
        </Stack>
      </Container>
    </>
  )
}
